/** Nom affiché pour un contributeur : compte Famla si connu, sinon nom saisi / e-mail. */
export function contributorDisplayName(c: {
    name?: string;
    email?: string;
    famla_fullname?: string;
}): string {
    const s = (c.famla_fullname || c.name || c.email || '').trim();
    return s || '?';
}

/** Initiales alignées sur `contributorDisplayName` (chaîne vide → "?"). */
export function initialsFromContributorDisplayName(displayName: string): string {
    const p = displayName.trim().split(/\s+/).filter(Boolean);
    if (!p.length) return '?';
    if (p.length === 1) return p[0].slice(0, 2).toUpperCase();
    return (p[0][0] + p[p.length - 1][0]).toUpperCase();
}

export function contributorInitials(c: {
    name?: string;
    email?: string;
    famla_fullname?: string;
}): string {
    const s = (c.famla_fullname || c.name || c.email || '').trim();
    return initialsFromContributorDisplayName(s);
}
